import React from 'react';
import { FormattedMessage } from 'react-intl';

export const frequentlyAskedQuestions = header => (
    <FormattedMessage
        id="buy.frequentlyAskedQuestions"
        defaultMessage="Questions about {header}"
        values={{ header }}
    />
);
